import React from "react";
import css from "classnames";
import styles from "./index.module.css";

const body = `Hi Haven Connect Support,
I received this error message from Haven Connect while trying to access the form.
And I tried to log in but I had the wrong login. What user is my application connected to?
Thank you!
`;
const subject = "Unable to access form.";
const FormRenderError: React.FC<{message?: React.ReactNode}> = ({ message }) => (
  <div className={css(styles.splash, "alert", "alert-warning")} role="alert">
    <span style={{ fontSize: 32 }} className="fa fa-warning" />
    <br />
    <br />
    There was a problem loading the form. {message && <><br /> {message} <br /></>}If the problem perists, please contact{" "}
    <a href={`mailto:support@havenconnect.com?subject=${
      encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`}>support@havenconnect.com</a>.
  </div>
);

export default FormRenderError;
